import { cn } from "@/lib/utils";

interface StepIndicatorProps {
  currentStep: number;
  onStepClick: (step: number) => void;
  totalSteps?: number;
}

export function StepIndicator({
  currentStep,
  onStepClick,
  totalSteps = 3,
}: StepIndicatorProps) {
  const steps = Array.from({ length: totalSteps }, (_, i) => i + 1);

  return (
    <div className="flex items-center justify-center mb-8 space-x-2">
      {steps.map((step) => (
        <div key={step} className="flex items-center">
          <button
            type="button"
            className={cn(
              "w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium cursor-pointer",
              currentStep === step
                ? "bg-primary text-primary-foreground"
                : "bg-muted text-muted-foreground hover:bg-primary/80 hover:text-primary-foreground",
            )}
            onClick={() => onStepClick(step)}
          >
            {step}
          </button>
          {step < totalSteps && (
            <div
              className={cn(
                "w-12 h-1 mx-2",
                step < currentStep ? "bg-primary" : "bg-muted",
              )}
            />
          )}
        </div>
      ))}
    </div>
  );
}
